import { createContext } from 'react';

export type HolidayShiftType = 'whole_day' | 'morning' | 'evening';

export interface CompanyHoliday {
  date: string;
  shift: HolidayShiftType;
  description: string;
}

export type SettingOrigin =
  | 'permission-matrix-layout'
  | 'project-issue-level'
  | 'default-currency'
  | 'work-shifts'
  | 'company_holidays';

interface SettingsContextValueType {
  handleCompanySettingChange: (origin: SettingOrigin, value: string) => void;
  permissionMatrixLayoutValue: string | null;
  projectIssueLevelValue: string | null;
  defaultCurrencyValue: string | null;
  defaultWorkShifts: string | null;
  companyHolidays: string | null;
}

const SettingsContext = createContext<SettingsContextValueType>({
  handleCompanySettingChange: () => {},
  permissionMatrixLayoutValue: null,
  projectIssueLevelValue: null,
  defaultCurrencyValue: null,
  defaultWorkShifts: null,
  companyHolidays: null,
});

export default SettingsContext;
